import React, { useEffect, useState } from 'react';
import { List, Input, Row, Popconfirm, Col, Form } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import AdnMessageError from '../adnMessage/AdnMessageError';

function AdnListComponent({
    size,
    data,
    renderItem,
    name,
    label,
    onListChange,
    disabled,
    maxLength
}) {
    const [text, setText] = useState('');
    const [listData, setListData] = useState([]);
    const [maxId, setMaxId] = useState(0);

    useEffect(() => {
        setListData(data);
    }, [data])

    const handleAdd = () => {
        if (text.trim() !== '') {

            const isTextExist = listData.some(item => item.text === text.trim());
            if (isTextExist) {
                AdnMessageError('Already exists in the list.');
                return;
            }

            const newItem = {
                id: maxId - 1,
                text
            };
            const newListData = [...listData, newItem];
            setListData(newListData);
            setText('');
            onListChange(newListData);
            setMaxId(maxId - 1);
        }
    };

    const handleDelete = (itemId) => {
        const updatedList = listData.filter(item => item.id !== itemId);
        setListData(updatedList);
        onListChange(updatedList);
    }



    return (
        <Form.Item
            label={label}
            name={name}
        >
            <Row gutter={16}>
                <Col span={24}>
                    {listData.length > 0 && (
                        <List
                            bordered
                            size={size}
                            dataSource={listData}
                            renderItem={item => (
                                <List.Item>
                                    {renderItem(item)}
                                    <Popconfirm
                                        title="Are you sure that you want to delete it?"
                                        onConfirm={() => handleDelete(item.id)}
                                    >
                                        {!disabled && <CloseOutlined type="primary" style={{ color: "#F00" }} />}
                                    </Popconfirm>
                                </List.Item>
                            )}
                        />
                    )}
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={24}>
                    <Input
                        disabled={disabled}
                        value={text}
                        onChange={e => setText(e.target.value)}
                        placeholder="Enter text"
                        suffix={!disabled &&
                            <PlusOutlined
                                type="primary"
                                onClick={handleAdd}
                                style={{ color: "#32CD32", cursor: 'pointer' }}
                            />
                        }
                        maxLength={maxLength}
                    />
                </Col>
            </Row>
        </Form.Item>
    );
}

export default AdnListComponent;
